import {useMutation} from '@apollo/react-hooks';

import type {
    SetGoogleMeetIsEnabled as SetGoogleMeetIsEnabledMutation,
    SetGoogleMeetIsEnabledVariables as SetGoogleMeetIsEnabledMutationVariables,
    SetGoogleMeetIsEnabledInput,
    GetMeetIntegration as GetMeetIntegrationQuery,
} from 'nutshell-graphql-types';

import SET_GOOGLE_MEET_IS_ENABLED from '../mutations/set-google-meet-is-enabled.graphql';
import GET_MEET_INTEGRATION from '../queries/get-meet-integration.graphql';

export function useSetGoogleMeetIsEnabled(): (arg1: SetGoogleMeetIsEnabledInput) => Promise<any> {
    const [setGoogleMeetIsEnabled] = useMutation<
        SetGoogleMeetIsEnabledMutation,
        SetGoogleMeetIsEnabledMutationVariables
    >(SET_GOOGLE_MEET_IS_ENABLED);

    return (input: SetGoogleMeetIsEnabledInput) =>
        setGoogleMeetIsEnabled({
            variables: {input},
            update: (proxy, mutationResults) => {
                const cacheResult: GetMeetIntegrationQuery | null | undefined = proxy.readQuery({
                    query: GET_MEET_INTEGRATION,
                });

                if (!cacheResult || !cacheResult.loggedInUser) {
                    return;
                }

                const updatedGoogleMeetIntegration =
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.setGoogleMeetIsEnabled &&
                    mutationResults.data.setGoogleMeetIsEnabled.googleMeetIntegration;

                if (!updatedGoogleMeetIntegration) return;

                proxy.writeQuery({
                    query: GET_MEET_INTEGRATION,
                    data: {
                        loggedInUser: {
                            ...cacheResult.loggedInUser,
                            googleMeetIntegration: updatedGoogleMeetIntegration,
                        },
                    },
                });
            },
        });
}
